import { X } from "lucide-react";
import { ImageUpload } from "./ImageUpload";


export function CategoryForm({
  category,
  index,
  canRemove,
  onRemove,
  onChange,
  onImageUpload,
  unitMeasurements,
}) {
  return (
    <div className="p-5 border border-[#E5E7EB] dark:border-[#2A2A2A] rounded-xl bg-[#FAFAFA] dark:bg-[#1A1A1A]">
      <div className="flex items-start justify-between mb-4">
        <h3 className="text-lg font-semibold text-[#111111] dark:text-white font-poppins">
          Category {index + 1}
        </h3>
        {canRemove && (
          <button
            onClick={onRemove}
            className="p-1.5 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 text-red-600 dark:text-red-400 transition-colors"
          >
            <X size={18} />
          </button>
        )}
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-[#111111] dark:text-white font-inter mb-2">
            Category Name *
          </label>
          <input
            type="text"
            value={category.name}
            onChange={(e) => onChange("name", e.target.value)}
            placeholder="e.g., Chairs, Tables, Linens"
            className="w-full px-4 py-2.5 rounded-lg border border-[#E5E7EB] dark:border-[#2A2A2A] bg-white dark:bg-[#262626] text-[#111111] dark:text-white placeholder-[#666666] dark:placeholder-[#A0A0A0] focus:outline-none focus:ring-2 focus:ring-[#62397f] dark:focus:ring-[#7C3AED] transition-all text-sm font-inter"
          />
        </div>


        <div>
          <label className="block text-sm font-medium text-[#111111] dark:text-white font-inter mb-2">
            Unit Measurement *
          </label>
          <select
            value={category.unitMeasurement}
            onChange={(e) => {
              onChange("unitMeasurement", e.target.value);
              if (e.target.value !== "Custom") {
                onChange("customUnitMeasurement", "");
              }
            }}
            className="w-full px-4 py-2.5 rounded-lg border border-[#E5E7EB] dark:border-[#2A2A2A] bg-white dark:bg-[#262626] text-[#111111] dark:text-white focus:outline-none focus:ring-2 focus:ring-[#62397f] dark:focus:ring-[#7C3AED] transition-all text-sm font-inter"
          >
            <option value="">Select unit measurement</option>
            {unitMeasurements.map((unit) => (
              <option key={unit} value={unit}>
                {unit}
              </option>
            ))}
          </select>
        </div>

        {category.unitMeasurement === "Custom" && (
          <div
            className="overflow-hidden transition-all duration-300 ease-in-out"
            style={{
              animation: "slideDown 0.3s ease-out",
            }}
          >
            <label className="block text-sm font-medium text-[#111111] dark:text-white font-inter mb-2">
              Custom Unit Measurement *
            </label>
            <input
              type="text"
              value={category.customUnitMeasurement}
              onChange={(e) =>
                onChange("customUnitMeasurement", e.target.value)
              }
              placeholder="e.g., Per Bundle, Per Package"
              autoFocus
              className="w-full px-4 py-2.5 rounded-lg border border-[#E5E7EB] dark:border-[#2A2A2A] bg-white dark:bg-[#262626] text-[#111111] dark:text-white placeholder-[#666666] dark:placeholder-[#A0A0A0] focus:outline-none focus:ring-2 focus:ring-[#62397f] dark:focus:ring-[#7C3AED] transition-all text-sm font-inter"
            />
          </div>
        )}

        <ImageUpload
          imagePreview={category.imagePreview}
          onImageUpload={onImageUpload}
          onImageRemove={() => {
            onChange("image", null);
            onChange("imagePreview", null);
          }}
        />
      </div>

      <style jsx="true">{`
        @keyframes slideDown {
          from {
            opacity: 0;
            max-height: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            max-height: 500px;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
